const Plant = () => {
  return (
    <div>
        Plant
    </div>
  );
};

export default Plant;